module.exports = __webpack_public_path__ + "static/img/Amp.da188bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/Amp.jpg
// module id = aaG5
// module chunks = 1